import { bludeltaRequest, BluDeltaResponse } from './network';
import store from 'store';
import { customerConfigKey } from 'lib/configStoreKey';

export interface ConfigInvoiceDetail {
  AutoProcessableThreshold: number;
  CanBeEmpty: boolean;
  InvoiceDetailTypeId: number;
  MultipleOccurrencesAllowed: boolean;
  IsQueryable: boolean;
  Name: string;
  Priority: string;
  PropertyPath: string;
}

export interface CustomerConfigResponse extends BluDeltaResponse {
  InvoiceDetails: ConfigInvoiceDetail[];
  RemoveGuiSplittingArea: boolean;
  SkipReleaseStep: boolean;
  Autoprocessing: string;
  DisplayName: string;
  MustHaveSupplierInValidation: boolean;
  MustHaveClientInValidation: boolean;
  SupplierScoreThreshold: number;
  CanDeleteInvoiceInValidation: boolean;
  IsClientVisible: boolean;
  IsSupplierVisible: boolean;
}

export function getConfigFromStore(): CustomerConfigResponse {
  return store.get(customerConfigKey);
}

export function getCustomerConfig(): Promise<CustomerConfigResponse> {
  return bludeltaRequest('GET', '/customerConfiguration');
}
